var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("保险管理系统")]),
              _c("el-breadcrumb-item", [_vm._v("保险申请")]),
              _c("el-breadcrumb-item", [_vm._v("查看详情")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dataLoading,
              expression: "dataLoading",
            },
          ],
          staticClass: "my-container box-shadow",
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                padding: "20px",
                "border-bottom": "1px solid #dbdbdb",
              },
            },
            [
              _c("div", { staticClass: "my-title" }, [_vm._v("保险申请详情")]),
              _vm.detail.applyBrief.status == "待反馈"
                ? _c(
                    "el-button",
                    {
                      staticStyle: { float: "right" },
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.showFeedbackDialog },
                    },
                    [_vm._v(" 反馈客户保险金额 ")]
                  )
                : _vm._e(),
              _vm.detail.applyBrief.status == "未投保"
                ? _c(
                    "el-button",
                    {
                      staticStyle: { float: "right" },
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.linkToFeedbackPage },
                    },
                    [_vm._v(" 投保反馈 ")]
                  )
                : _vm._e(),
              _c("div", { staticStyle: { clear: "both" } }),
            ],
            1
          ),
          _c("div", { staticClass: "main-info" }, [
            _c("div", { staticClass: "info-item" }, [
              _c("div", { staticClass: "my-row" }, [
                _c("div", { staticClass: "text" }, [_vm._v("申请情况")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.applyBrief.status)),
                ]),
              ]),
              _vm._m(0),
              _c("div", { staticClass: "my-row" }, [
                _c("div", { staticClass: "text" }, [_vm._v("申请日期")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("formatDateByCN")(_vm.detail.applyBrief.applyTime)
                    )
                  ),
                ]),
              ]),
            ]),
            _vm._m(1),
            _c("div", { staticClass: "info-item" }, [
              _c("div", { staticClass: "my-row" }, [
                _c("div", { staticClass: "text" }, [_vm._v("车牌号")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.applyBrief.plateNumber)),
                ]),
              ]),
              _c("div", { staticClass: "my-row" }, [
                _c("div", { staticClass: "text" }, [_vm._v("购车价格")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.applyBrief.buyCarPrice) + "元"),
                ]),
              ]),
              _c("div", { staticClass: "my-row" }, [
                _c("div", { staticClass: "text" }, [_vm._v("购车时间")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.applyBrief.buyCarDate)),
                ]),
              ]),
              _c("div", { staticClass: "my-row" }, [
                _c("div", { staticClass: "text" }, [_vm._v("投保城市")]),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.detail.applyBrief.city)),
                ]),
              ]),
            ]),
            _vm.detail.applyBrief.status == "未投保"
              ? _c("div", [
                  _vm._m(2),
                  _c("div", { staticClass: "info-item" }, [
                    _c("div", { staticClass: "my-row" }, [
                      _c("div", { staticClass: "text" }, [
                        _vm._v("保险预报价"),
                      ]),
                      _c("div", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.detail.applyReturnInfo.price)),
                      ]),
                    ]),
                    _c("div", { staticClass: "my-row" }, [
                      _c("div", { staticClass: "text" }, [_vm._v("投保年限")]),
                      _c("div", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.detail.applyReturnInfo.yearNo)),
                      ]),
                    ]),
                    _c("div", { staticClass: "my-row" }, [
                      _c("div", { staticClass: "text" }, [
                        _vm._v("保险专员电话"),
                      ]),
                      _c("div", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.detail.applyReturnInfo.tel)),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.detail.applyBrief.status == "已投保"
              ? _c("div", [
                  _vm._m(3),
                  _c("div", { staticClass: "info-item" }, [
                    _c("div", { staticClass: "my-row" }, [
                      _c("div", { staticClass: "text" }, [_vm._v("保险金额")]),
                      _c("div", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.detail.returnInfo.price) + "元"),
                      ]),
                    ]),
                    _c("div", { staticClass: "my-row" }, [
                      _c("div", { staticClass: "text" }, [_vm._v("投保年限")]),
                      _c("div", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.detail.returnInfo.yearNo) + "年"),
                      ]),
                    ]),
                    _c("div", { staticClass: "my-row" }, [
                      _c("div", { staticClass: "text" }, [_vm._v("保单号")]),
                      _c("div", { staticClass: "text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detail.returnInfo.cno == ""
                              ? "未填写"
                              : _vm.detail.returnInfo.cno
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._m(4),
                  _c(
                    "div",
                    { staticClass: "info-item" },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: {
                            "margin-top": "20px",
                            "margin-left": "195px",
                          },
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.showPDF },
                        },
                        [_vm._v(" 查看电子保单 ")]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticStyle: { "text-align": "center", color: "#007373" },
          attrs: { title: "反馈客户保险金额", visible: _vm.dialogFormVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticStyle: { width: "400px", margin: "auto" },
              attrs: { id: "form", model: _vm.form, rules: _vm.rules },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "保险金额：", prop: "amount" } },
                [
                  _c("el-input", {
                    staticStyle: { float: "left", width: "250px" },
                    attrs: {
                      size: "small",
                      placeholder: "请输入保险金额",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.amount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "amount", $$v)
                      },
                      expression: "form.amount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "投保年限：", prop: "year" } },
                [
                  _c("el-input", {
                    staticStyle: { float: "left", width: "250px" },
                    attrs: {
                      size: "small",
                      placeholder: "请输入投保年限",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.year,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "year", $$v)
                      },
                      expression: "form.year",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "保险专员电话：", prop: "tel" } },
                [
                  _c("el-input", {
                    staticStyle: { float: "left", width: "250px" },
                    attrs: {
                      size: "small",
                      placeholder: "请输入保险专员电话",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.tel,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "tel", $$v)
                      },
                      expression: "form.tel",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              staticStyle: { margin: "50px auto auto" },
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "my-row" }, [
      _c("div", { staticClass: "text" }, [_vm._v("保险类型")]),
      _c("div", { staticClass: "text" }, [_vm._v("汽车保险")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "gap" }, [
      _c("div", [_vm._v("投保人信息")]),
      _c("hr"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "gap" }, [
      _c("div", [_vm._v("反馈保险")]),
      _c("hr"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "gap" }, [
      _c("div", [_vm._v("投保信息")]),
      _c("hr"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "gap" }, [
      _c("div", [_vm._v("电子保单")]),
      _c("hr"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }